const create = (api) => {
    const createAccess = (username) => {
        return api.post(`/UserManagement/v2/users/apiclient?userName=${username}`)
    }

    const getApiUsers = () => {
        return api.get(`/UserManagement/v2/users/apiusers`)
    }

    const deleteAccess = (idApiClient, clientName) => {
        return api.delete(`/UserManagement/v2/users/apiclient?idApiClient=${idApiClient}&clientNAme=${clientName}`)
    }

    return {
        createAccess,
        getApiUsers,
        deleteAccess
    }
    
}

export default { create }